const LandingsList = () => import(/* webpackChunkName 'LandingsList' */ '@/components/Subscriptions/Landing/LandingsList/LandingsList.vue');
const LandingDetail = () => import(/* webpackChunkName 'LandingDetail' */ '@/components/Subscriptions/Landing/LandingDetail/LandingDetail.vue');
const LandingCreate = () => import(/* webpackChunkName 'LandingCreate' */ '@/components/Subscriptions/Landing/LandingCreate/LandingCreate.vue');

export default {
    path: 'subscriptions/landings',
    name: 'subscriptions_landings',
    redirect: 'subscriptions/landings',
    meta: {
        label: 'Landings'
    },
    component: {
        name: 'SubscriptionsLandings',
        render(c: any) {
            return c('router-view');
        }
    },
    children: [
        {
            path: '/',
            name: 'subscriptions_landings_list',
            meta: {
                label: 'List'
            },
            props: true,
            component: LandingsList
        },
        {
            path: 'landing-detail/:id',
            name: 'subscriptions_landing_detail',
            meta: {
                label: 'Detail'
            },
            props: true,
            component: LandingDetail
        },
        {
            path: 'landing-create',
            name: 'subscriptions_landing_create',
            meta: {
                label: 'Create'
            },
            props: true,
            component: LandingCreate
        }
    ]
};
